module.exports = __webpack_public_path__ + "media/images/kaoawase/top/reason1-bcfe626c9d7099a187be83a5b94b0b40.jpg";